var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32CircleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,4,30)",
    d: "M23 14C23 7.924868 18.075133 3 12 3V1C19.1797 1 25 6.820299 25 14H23ZM12 3C5.924868 3 1 7.924868 1 14H-1C-1 6.820299 4.820298 1 12 1V3ZM1 14C1 20.075133 5.924868 25 12 25V27C4.820298 27-1 21.179703-1 14H1ZM12 25C18.075133 25 23 20.075133 23 14H25C25 21.179703 19.1797 27 12 27V25Z",
    fill: "#0a7e85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,14.75,22)",
    d: "M2.5 1.25C2.5 .559644 1.940356 0 1.25 0 .559644 0 0 .559644 0 1.25 0 1.940356 .559644 2.5 1.25 2.5 1.940356 2.5 2.5 1.940356 2.5 1.25Z",
    fill: "#0a7e85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,15,18)",
    d: "M0 7C0 7.552285 .447715 8 1 8 1.552285 8 2 7.552285 2 7V1C2 .447715 1.552285 0 1 0 .447715 0 0 .447715 0 1V7Z",
    fill: "#0a7e85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32CircleWarning);
export default __webpack_public_path__ + "static/media/icon32_circle_warning.073fadf476462d7537f02eaef655c9de.svg";
export { ForwardRef as ReactComponent };